function registerGlobal(MasterCSS) {
    if (!globalThis.MasterCSS) globalThis.MasterCSS = MasterCSS;
}

export { registerGlobal as default };
